/**
 * @mixin
 */
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            default: ""
        },
        fieldClass: {
            type: Object
        },
        type: {
            type: String,
            default: "text"
        },
        value: {
            default: null
        },
        labelClass: {
            type: Object
        },
        placeholder: {
            type: String,
            default: ""
        },
        glyph: {
            type: String,
            default: ""
        },
        glyphPosition: {
            validator: prop => {
                return (typeof prop === "string") || !!prop.match(/^(left|right)$/i)
            },
            default: "right"
        },
        size: {
            type: Number,
            default: 0
        },
        autoselect: {
            type: Boolean,
            default: false // if false, autoselect only works on number type fields
        },
        editable: {
            type: Boolean,
            default: true
        },
        live: {
            type: Boolean,
            default: true
        },
        error: {
            type: String,
            default: ""
        },
        hint: {
            type: String,
            default: ""
        },
        max: {
            type: Number,
            default: 0
        }
    }
}
